import React from "react";
import { User } from '../models/User';
import { EmptyPhoto, Photo } from '../components';
import { getConfiguration } from "../models";

export interface HeroProps {
    users: User[];
    loading: boolean;
}

export const Hero = ({ users, loading }: HeroProps) => {
    console.log(users);
    return <div className="app-paz-collage">
        {users.map((user, index) => loading === true
            ? <EmptyPhoto key={index} className={`small${index + 1}`} />
            : <Photo key={index}
                photo={user.photo}
                className={`${index < 4 ? `small${index + 1}` : `big${6 - index}`}`}
                tooltip={`${user.name} (${user.age} m., ${user.city})`}
                link={`${getConfiguration().serviceEndpoint}/narys.cfm?narys=${user.userId}`} />)}
    </div>;
};